import '@webmotors/consumer-shared-ui/styles.css';
import '@/styles/globals.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { clearAnalyticsHistory } from '@/hooks/analytics';
import { exposeBuildVersion, initDatadog } from '@/services/observability';

exposeBuildVersion();
initDatadog();
// Zera o dedupe de page views (adobeLaunchHistory) no boot — o histórico é
// compartilhado entre os apps do mesmo origin e reusamos pageNames da garagem,
// então sem isso o page view inicial pode ser pulado e nunca chega ao Adobe.
clearAnalyticsHistory();

const rootElement = document.getElementById('root');

if (!rootElement) {
	throw new Error('Root element not found. Ensure index.html has a <div id="root"></div>.');
}

createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>
);
